import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './UserPop.module.scss';
import useCopy from '../../utils/useCopy';
import copyImg from '../../assets/images/copy.svg';
import { clearStatus } from '../../utils/auth';

type Props = {
  ontId: string;
  onOut: () => void;
}

const UserPop: React.FC<Props> = ({ ontId, onOut }) => {
  const { t } = useTranslation();
  const copyRef = useRef(null);
  useCopy(copyRef);
  const logout = () => {
    clearStatus();
    onOut();
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>ONT ID</div>
      <div className={styles.detailWrapper}>
        <div className={styles.ont}>{ontId}</div>
        <img className={styles.copy} ref={copyRef} src={copyImg} alt="" data-clipboard-text={ontId} />
      </div>
      {/* eslint-disable-next-line max-len */}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/interactive-supports-focus */}
      <div className={`${styles.link} ${styles.danger}`} onClick={logout} role="button">{t('logout')}</div>
    </div>
  );
};
export default UserPop;
